// ============================================================
//  PRODUCTOS - Edita aquí para agregar/modificar productos
// ============================================================

export const CATEGORIES = [
  { id: 'todos',      label: 'Todos',      icon: '🏪' },
  { id: 'mascotas',   label: 'Mascotas',   icon: '🐾' },
  { id: 'hogar',      label: 'Hogar',      icon: '🏠' },
  { id: 'limpieza',   label: 'Limpieza',   icon: '🧹' },
  { id: 'tecnologia', label: 'Tecnología', icon: '💻' },
  { id: 'ofertas',    label: 'Ofertas',    icon: '🏷️' },
];

export const PRODUCTS = [

  // ══════════════════════════════════════════════════════════
  //  🐾 MASCOTAS
  // ══════════════════════════════════════════════════════════
  {
    id: 1,
    name: 'Cama Premium para Mascotas',
    category: 'mascotas',
    price: 31990,
    originalPrice: 54990,
    rating: 4.8,
    reviews: 1190,
    badge: 'Más vendido',
    badgeColor: '#e8860a',
    description: 'Cama ultra suave con memoria de forma. Ideal para perros y gatos de todo tamaño. Funda removible y lavable.',
    features: ['Memory foam', 'Funda lavable', 'Antideslizante', 'Tallas S/M/L'],
    image: '/images/Imagen1.png',
    paymentLink: 'https://meli.la/2dcQTDn',
  },
  {
    id: 2,
    name: 'Bolso Transportador Mascota Gato Michi Portatil Con Alfombra',
    category: 'mascotas',
    price: 11990,
    originalPrice: null,
    rating: 4.8,
    reviews: 190,
    badge: 'Nuevo',
    badgeColor: '#2d7a42',
    description: 'Bolso transportador para mascotas gato. Con alfombra acolchada y compartimento para accesorios.',
    features: ['Alfombra acolchada', 'Compartimento accesorios', 'Cierre seguro', 'Lavable'],
    image: '/images/Imagen2.png',
    paymentLink: 'https://meli.la/1pS7htQ',
  },
  {
    id: 3,
    name: 'Churu Gato Sabor Atun Variedades Pack X50 Tubos',
    category: 'mascotas',
    price: 25200,
    originalPrice: 36000,
    rating: 5.0,
    reviews: 7224,
    badge: null,
    badgeColor: '#e8860a',
    description: 'Peso neto: 700 g,Hidratación saludable para gatos, textura cremosa,En Sabor: Atún.',
    features: ['churu Gato sabor atún,', 'snack gatos', 'Hidratación', 'Apto gatitos'],
    image: '/images/Imagen3.png',
    paymentLink: 'https://meli.la/23gsX2X',
  },
  {
    id: 4,
    name: '100 Pañales Sabanillas Mascotas Perros y Gatos 90x60cm Aspor 5 Capas absorción ultra Mejorada',
    category: 'mascotas',
    price: 19988,
    originalPrice: 27989,
    rating: 4.8,
    reviews: 1134,
    badge: 'Oferta',
    badgeColor: '#e8860a',
    description: 'Pañales absorbentes para perros y gatos. 5 capas de absorción ultra mejorada. Tamaño: 90x60cm.',
    features: ['5 capas absorción', 'Tamaño 90x60cm', 'Para perros y gatos', 'Fácil de cambiar'],
    image: '/images/Imagen4.png',
    paymentLink: 'https://meli.la/1tHtgye',
  },
  {
    id: 5,
    name: 'Arena Sanitaria Aglutinante Easy Clean 24kg/30lts',
    category: 'mascotas',
    price: 16490,
    originalPrice: 22900,
    rating: 4.9,
    reviews: 3091,
    badge: 'Popular',
    badgeColor: '#2d7a42',
    description: 'Arena sanitaria aglutinante Easy Clean 24kg/30lts. Elimina olores y mantiene el área de arena limpia.',
    features: ['Aglatinante', '24kg/30lts', 'Elimina olores', 'Fácil limpieza'],
    image: '/images/Imagen5.png',
    paymentLink: 'https://meli.la/1xo2WPw',
  },
  {
    id: 6,
    name: 'Pedigree Alimento Seco Perro Adulto Carne Pollo Cereal 15kg',
    category: 'mascotas',
    price: 27990,
    originalPrice: 33990,
    rating: 4.8,
    reviews: 14264,
    badge: 'Nuevo',
    badgeColor: '#2d7a42',
    description: 'Alimento seco para perros adultos con sabor a pollo y cereales. Nutritivo y delicioso.',
    features: ['15kg', 'Sabor pollo', 'Nutritivo', 'Apto para perros adultos'],
    image: '/images/Imagen6.png',
    paymentLink: 'https://meli.la/1SeEoTh',
  },
  {
    id: 7,
    name: 'Bolsas Biodegradables Poopa Bag Recoge Fecas Perro 240 Unidades',
    category: 'mascotas',
    price: 5739,
    originalPrice: 8390,
    rating: 5.0,
    reviews: 572,
    badge: null,
    badgeColor: '#e8860a',
    description: 'Bolsas biodegradables para recoger las fecas de tu perro. 240 unidades. Fáciles de usar y limpiar.',
    features: ['240 unidades', 'Biodegradable', 'Fáciles de usar', 'Lavables'],
    image: '/images/Imagen7.png',
    paymentLink: 'https://meli.la/2UAwM3o',
  },
  {
    id: 8,
    name: 'Casa para Perro Pequeña Cool Pets de Plástico con Techo Azul',
    category: 'mascotas',
    price: 38890,
    originalPrice: 49990,
    rating: 4.7,
    reviews: 289,
    badge: null,
    badgeColor: '#e8860a',
    description: 'Tamaño de la raza: Mediana, Material: Plástico, Color: Azul, Fácil de limpiar, Resistente a la intemperie.',
    features: ['casa para perro', 'Tamaño de la raza: Mediana', 'Resistente al agua', 'Fácil de armar.'],
    image: '/images/Imagen8.png',
    paymentLink: 'https://meli.la/2ZJ9Hfy',
  },
  {
    id: 9,
    name: 'Casa De Perro 98x90x96cm Verde Casa Viva',
    category: 'mascotas',
    price: 84380,
    originalPrice: 129990,
    rating: 4.7,
    reviews: 22,
    badge: 'Más vendido',
    badgeColor: '#e8860a',
    description: 'Tamaño de la raza: Mediana/Grande, Casa para perros de 98x90x96 cm,Estructura de polipropileno 100% resistente y duradera.',
    features: ['casa viva', 'Vlanco/verde', 'Bolsillo 98x90x96', 'Fácil de limpiar y montar sin herramientas'],
    image: '/images/Imagen9.png',
    paymentLink: 'https://meli.la/15nGnob',
  },
  {
    id: 10,
    name: 'Escalera Mascota Perro Gato Con Almacenamiento Plegable Gris',
    category: 'mascotas',
    price: 26990,
    originalPrice: 54990,
    rating: 4.8,
    reviews: 96,
    badge: 'Popular',
    badgeColor: '#2d7a42',
    description: 'Escalera plegable con almacenamiento para mascotas. Ideal para perros y gatos.',
    features: ['Plegable', 'Almacenamiento', 'Ideal para perros y gatos', 'Fácil de limpiar'],
    image: '/images/Imagen10.png',
    paymentLink: 'https://meli.la/28UfMgF',
  },
  {
    id: 11,
    name: 'Artri-tabs Suplemento Articular Perro X60 Palatable',
    category: 'mascotas',
    price: 26990,
    originalPrice: null,
    rating: 4.9,
    reviews: 523,
    badge: null,
    badgeColor: '#e8860a',
    description: 'Premios naturales sin conservantes artificiales. Ideales para entrenamiento y recompensa. Sabor pollo.',
    features: ['100% natural', 'Sin conservantes', 'Apto cachorros', 'Bolsa resellable'],
    image: '/images/Imagen12.png',
    paymentLink: 'https://meli.la/26cSjYK',
  },
  {
    id: 12,
    name: 'Snack Para Gatos Cremi Pollo Mix X60 Unidades 720g Naturalistic',
    category: 'mascotas',
    price: 15990,
    originalPrice: 22280,
    rating: 5.0,
    reviews: 2360,
    badge: 'Nuevo',
    badgeColor: '#2d7a42',
    description: 'Snack para gatos con sabor a pollo. X60 unidades, 720g. Naturalistic.',
    features: ['Sabor a pollo', 'X60 unidades', '720g', 'Naturalistic'],
    image: '/images/Imagen11.png',
    paymentLink: 'https://meli.la/2QQ3en8',
  },
  {
    id: 13,
    name: 'Alimento Bravery Salmón Perro Adulto Raza Mediana y Grande 12 Kg',
    category: 'mascotas',
    price: 68200,
    originalPrice: 79990,
    rating: 4.9,
    reviews: 6472,
    badge: null,
    badgeColor: '#e8860a',
    description: 'Alimento para perros adultos de raza mediana y grande con salmón.',
    features: ['alimento perro mediano/grande', '26% proteína', 'Protector de la salud oral que ayuda a eliminar el sarro', 'Rico en minerales esenciales como calcio y fósforo'],
    image: '/images/Imagen13.png',
    paymentLink: 'https://meli.la/2PTjxUY',
  },
   {
    id: 14,
    name: 'Farmina N&D Prime Alimento Balanceado Gato Adulto 7.5kg',
    category: 'mascotas',
    price: 54790,
    originalPrice: null,
    rating: 4.9,
    reviews: 2428,
    badge: null,
    badgeColor: '#e8860a',
    description: 'Alimento para gatos adultos de 7.5kg.',
    features: ['alimento gato adulto', '26% proteína', 'Protector de la salud oral que ayuda a eliminar el sarro', 'Rico en minerales esenciales como calcio y fósforo'],
    image: '/images/Imagen14.png',
    paymentLink: 'https://meli.la/1oeiZaZ',
  },
 {
    id: 15,
    name: 'Alimento Pro Plan OptiAge Active Mind para perro senior de raza mediana y grande sabor pollo y arroz de 15 kg',
    category: 'mascotas',
    price:55851,
    originalPrice: null,
    rating: 4.9,
    reviews: 8212,
    badge: null,
    badgeColor: '#e8860a',
    description: 'Alimento para perros seniors de raza mediana y grande con sabor a pollo y arroz.',
    features: ['alimento perro senior', '26% proteína', 'Protector de la salud oral que ayuda a eliminar el sarro', 'Rico en minerales esenciales como calcio y fósforo'],
    image: '/images/Imagen15.png',
    paymentLink: 'https://meli.la/17amkC6',
  },
  {
    id: 16,
    name: 'Alimento Royal Canin Feline Health Nutrition Indoor 27 para gato adulto todos los tamaños sabor mix de 7.5 kg',
    category: 'mascotas',
    price: 54758,
    originalPrice: 68200,
    rating: null,
    reviews: null,
    badge: 'Nuevo',
    badgeColor: '#2d7a42',
    description: 'Alimento para gatos adultos de 7.5kg.',
    features: ['alimento gato adulto', 'proteína bruta 27% para un crecimiento y desarrollo muscular óptimo', 'Protector de la salud oral que ayuda a eliminar el sarro', 'Rico en minerales esenciales como calcio y fósforo'],
    image: '/images/Imagen17.png',
    paymentLink: 'https://meli.la/2Ak9LQh',
  },
   {
    id: 17,
    name: 'Pro Plan Sensitive Skin Perro Adult Raza Med Gde Salmón 12kg',
    category: 'mascotas',
    price:47267,
    originalPrice: 69990,
    rating: 4.9,
    reviews: 897,
    badge: null,
    badgeColor: '#e8860a',
    description: 'Alimento para perros Formulado con salmón, ideal para pieles sensibles.',
    features: ['Peso neto: 12 kg', 'Proteína bruta del 25% para mantener la salud y energía de tu perro.', 'Protector de la salud oral para un aliento fresco'],
    image: '/images/Imagen18.png',
    paymentLink: 'https://meli.la/2VYLAdR',
  },
   {
    id: 18,
    name: 'Alimento Royal Canin Size Health Nutrition Mini adulto para perro adulto de raza pequeña sabor mix de 7.5 kg',
    category: 'mascotas',
    price:55851,
    originalPrice: 69500,
    rating: 4.9,
    reviews: 8212,
    badge: null,
    badgeColor: '#e8860a',
    description: 'Peso neto: 7.5 kg,Alimento para perros adultos de raza pequeña con sabor mix.',
    features: ['Peso neto: 7.5 kg', 'Aporte de 8.5% de minerales esenciales para la salud, 11% de humedad para mantener la frescura y calidad del alimento', 'Contenido calórico de 3.900 kcal/kg para energía adaptada.'],
    image: '/images/Imagen20.png',
    paymentLink: 'https://meli.la/18U313Y',
  },




  // ══════════════════════════════════════════════════════════
  //  🏠 HOGAR
  // ══════════════════════════════════════════════════════════
  {
    id: 19,
    name: 'Almohada Ortopedica Cervical Terapeutica Con Memoria Howell Espuma Viscoelástica Memory Foam X2',
    category: 'hogar',
    price: 19980,
    originalPrice: 24990,
    rating: 4.4,
    reviews: 2506,
    badge: 'Popular',
    badgeColor: '#2d7a42',
    description: 'lmohada Ortopedica Cervical Terapeutica Con Memorias.',
    features: ['Espesor: 35 cm', 'Altura: 10 cm', 'Largo: 55 cm', 'Unidades por pack: 2'],
    image: '/images/Imagen21.png',
    paymentLink: 'https://meli.la/1TB2yDN',
  },
  {
    id: 20,
    name: 'Máquina Molinillo Granos Blanik Bmg081 Color Negro',
    category: 'hogar',
    price: 30990,
    originalPrice: 49990,
    rating: 4.7,
    reviews: 955,
    badge: 'Nuevo',
    badgeColor: '#2d7a42',
    description: 'Sistema de ajuste para regular el grosor de la molienda desde extra fino hasta grueso según el tipo de preparación, Contenedor con capacidad de 230 gramos para almacenar granos enteros y procesar múltiples porciones en un solo ciclo.',
    features: ['400ml', 'Luz LED 7 colores', 'Apagado automático', 'Ultra silencioso'],
    image: '/images/Imagen22.png',
    paymentLink: 'https://meli.la/2HEhyRY',
  },
  {
    id: 21,
    name: 'Zapatero Organizador Banca Probador 51x80x30cm Blanco',
    category: 'hogar',
    price: 39990,
    originalPrice: 55990,
    rating: 4.6,
    reviews: 2611,
    badge: 'Más vendido',
    badgeColor: '#e8860a',
    description: 'Tres estantes para maximizar el almacenamiento, Dimensiones compactas de 51x80x30 cm para espacios reducidos,Capacidad para 11 pares de zapatos organizados.',
    features: [ 'Color Blanco', 'medidas 51 cm x 80 cm x 30 cm', 'Peso 11,5 kg'],
    image: '/images/Imagen23.png',
    paymentLink: 'https://meli.la/2R9ne9v',
  },
  {
    id: 22,
    name: 'Batería 10 Piezas Daily Cook Color Plateado en Acero Inoxidable',
    category: 'hogar',
    price: 79990,
    originalPrice: 109990,
    rating: 4.7,
    reviews: 244,
    badge: null,
    badgeColor: '#e8860a',
    description: 'Kit completo de 10 piezas de cocina en acero inoxidable. Incluye ollas, sartenes y tapas. Compatible con todo tipo de cocinas.',
    features: ['Marca Tefal', '10 piezas', 'Color plateado', 'Acero inoxidable duradero'],
    image: '/images/Imagen24.png',
    paymentLink: 'https://meli.la/1yRbvSL',
  },
  {
    id: 23,
    name: 'Fondue Maker Bfm098 Blanik Negro',
    category: 'hogar',
    price: 29990,
    originalPrice: 25990,
    rating: 4.9,
    reviews: 122,
    badge: 'Popular',
    badgeColor: '#2d7a42',
    description: 'Fondue maker con diseño moderno. Ideal para compartir experiencias culinarias.',
    features: ['Capacidad 1.5L', 'Materiales de alta calidad', 'Fácil de limpiar', 'Diseño ergonómico'],
    image: '/images/Imagen25.png',
    paymentLink: 'https://meli.la/1woKc6X',
  },


  // ══════════════════════════════════════════════════════════
  //  🧹 LIMPIEZA
  // ══════════════════════════════════════════════════════════
  {
    id: 24,
    name: 'Cubre Colchon Impermeable 2 Plazas + Fundas Okaeri Color Blanco',
    category: 'limpieza',
    price: 9452,
    originalPrice: 12990,
    rating: 4.7,
    reviews: 3389,
    badge: '-27%',
    badgeColor: '#e8860a',
    description: 'Cubre colchón impermeable para 2 plazas + fundas Okaeri color blanco. Protege tu colchón de manchas y líquidos.',
    features: ['Material impermeable', 'Funda de microfibra', 'Fácil de limpiar', 'Compatible con colchones de 2 plazas'],
    image: '/images/Imagen30.png',
    paymentLink: 'https://meli.la/14mompC',
  },
  {
    id: 25,
    name: 'Limpiador Vapor Portátil Alta Presión 105°c Cocina Baño Auto',
    category: 'limpieza',
    price: 37430,
    originalPrice: 67941,
    rating: 4.4,
    reviews: 24,
    badge: 'Nuevo',
    badgeColor: '#2d7a42',
    description: 'Limpiador a vapor portátil con alta presión a 105°C. Ideal para limpiar cocina, baño y auto. Elimina grasa y suciedad sin químicos.',
    features: ['Alta presión de vapor a 105°C', 'Portátil y fácil de usar', 'Ideal para limpiar cocina, baño y auto', 'Elimina grasa y suciedad sin químicos'],
    image: '/images/Imagen31.png',
    paymentLink: 'https://meli.la/19fSaZX',
  },
{
    id: 26,
    name: 'Hidrolavadora Nappo 1800w con Jabonera 5mts Manguera Color Rojo',
    category: 'limpieza',
    price: 54990,
    originalPrice: 129990,
    rating: 4.8,
    reviews: 1787,
    badge: 'Nuevo',
    badgeColor: '#2d7a42',
    description: 'Hidrolavadora Nappo 1800w con Jabonera 5mts Manguera Color Rojo. Ideal para limpiar cocina, baño y auto. Elimina grasa y suciedad sin químicos.',
    features: ['Potencia 1800W', 'Jabonera incluida', 'Manguera de 5 metros', 'Ideal para limpiar cocina, baño y auto'],
    image: '/images/Imagen32.png',
    paymentLink: 'https://meli.la/2WdgzTD',
  },



  // ══════════════════════════════════════════════════════════
  //  💻 TECNOLOGÍA
  // ══════════════════════════════════════════════════════════
  {
    id: 27,
    name: 'Ezviz CS-DL05 Cerradura Inteligente Con Huella Dactilar Color Gris',
    category: 'tecnologia',
    price: 124990,
    originalPrice: null,
    rating: 4.9,
    reviews: 1931,
    badge: 'Oferta',
    badgeColor: '#e8860a',
    description: 'Dirección de la cerradura: Derecha/Izquierda, Acabado: Mate, Mecanismos de apertura: biometría, contraseña y tarjeta,Soporta hasta 50 tarjetas MIFARE.',
    features: ['15W carga rápPara aberturas de 3 cm a 11 cm de grosor', 'Soporta hasta 50 contraseñas', 'Soporta hasta 50 tarjetas MIFARE', 'Alarma de seguridad integrada'],
    image: '/images/Imagen26.png',
    paymentLink: 'https://meli.la/1hist4m',
  },
  {
    id: 28,
    name: 'Nintendo Switch 2 System',
    category: 'tecnologia',
    price: 544574,
    originalPrice: 626990,
    rating: 4.8,
    reviews: 861,
    badge: 'Nuevo',
    badgeColor: '#2d7a42',
    description: 'Capacidad: 256 GB, Pantalla táctil LCD de 7.9" con resolución 1080p y soporte para HDR, ',
    features: ['Aluminio premium', '6 alturas', 'Plegable', 'Ventilación activa'],
    image: '/images/Imagen27.png',
    paymentLink: 'https://meli.la/2AvtzzG',
  },
    {
    id: 29,
    name: 'Kit De Internet Via Satélite Starlink Mini Blanco',
    category: 'tecnologia',
    price: 276277,
    originalPrice: null,
    rating: 4.8,
    reviews: 59226,
    badge: 'Nuevo',
    badgeColor: '#2d7a42',
    description: 'Unidades por pack: 1, Velocidad transmisión 150MBps, Latencia 20-40 ms, Requiere suscripción mensual, Cobertura global en áreas rurales y remotas.',
    features: ['Almacenaje 112 m', 'Frecuencia 50Hz/60 Hz' ,'Velocidad transmisión 150MBps', 'Latencia 20-40 ms'],
    image:'/images/Imagen28.png',
    paymentLink: 'https://meli.la/1CU7iyY',
  },
     {
    id: 30,
    name: 'Reloj Smartwatch Xiaomi Redmi Watch 5 Lite 1,96 Amoled Bt Gps - Black',
    category: 'tecnologia',
    price: 43950,
    originalPrice: 59990,
    rating: 4.8,
    reviews: 30039,
    badge: 'Nuevo',
    badgeColor: '#2d7a42',
    description: 'Pantalla AMOLED de 1,96 pulgadas con resolución de 410 x 502 píxeles para leer notificaciones y mensajes con nitidez., Seguimiento de salud con monitorización de frecuencia cardíaca las 24 horas, seguimiento del sueño y monitoreo del estrés para un bienestar integral.',
    features: ['Color negro', 'Pantalla AMOLED de 1,96 pulgadas', 'Seguimiento de salud integral', 'Resistencia al agua 5 ATM'],
    image:'/images/Imagen29.png',
    paymentLink: 'https://meli.la/1jj1NoQ',
  },
 {
    id: 31,
    name: 'Dongle Usb Carplay Android Auto Inalámbrico 2 En 1 Wifi 2.4/5g Bluetooth 5.0 800+ Modelos Ota Carplay Siri Google Asistente Voz',
    category: 'tecnologia',
    price: 15290,
    originalPrice: 17490,
    rating: 4.4,
    reviews: 122,
    badge: 'Nuevo',
    badgeColor: '#2d7a42',
    description: 'Conexión inalámbrica compatible con CarPlay y Android Auto para evitar cables cada vez que uses el auto.Transmisión rápida y estable con Bluetooth para emparejamiento initial y WiFi 2.4/5G para datos.Compatible con 800+ modelos y se vincula automáticamente al encender el vehículo.',
    features: ['Controla llamadas, GPS y música con comandos de voz, aumentando la seguridad al conducir.Instalación sencilla: conecta al puerto USB tipo A para modernizar tu sistema multimedia'],
    image:'/images/Imagen33.png',
    paymentLink: 'https://meli.la/1jj1NoQ',
  },
   {
    id: 32,
    name: 'Termolaminadora Plastificadora +cortador De Papel +300 Micas',
    category: 'tecnologia',
    price: 27990,
    originalPrice: 45980,
    rating: 4.8,
    reviews: 3580,
    badge: 'Nuevo',
    badgeColor: '#2d7a42',
    description: 'Termolaminadora plastificadora con cortador de papel y 300 micas incluidas. Ideal para proteger documentos, fotos y tarjetas. Fácil de usar y rápida.',
    features: ['Termolaminadora plastificadora', 'Cortador de papel incluido', '300 micas de 80 micrones', 'Ideal para proteger documentos, fotos y tarjetas'],
    image:'/images/Imagen34.png',
    paymentLink: 'https://meli.la/2rAuckg',
  },
  {
    id: 33,
    name: 'Localizador de Objetos Smart Tag 2 Black Samsung',
    category: 'tecnologia',
    price: 21427,
    originalPrice: 24990,
    rating: 4.8,
    reviews: 2407,
    badge: 'Nuevo',
    badgeColor: '#2d7a42',
    description: 'Localizador de objetos Smart Tag 2 Black Samsung. Ideal para encontrar llaves, billeteras y otros accesorios importantes.',
    features: ['Localizador de objetos', 'Compatibilidad con Samsung', 'Diseño compacto', 'Fácil de usar'],
    image:'/images/Imagen35.png',
    paymentLink: 'https://meli.la/1EHPdo1',
  },
 


  // ══════════════════════════════════════════════════════════
  //  🏷️ OFERTAS
  // ══════════════════════════════════════════════════════════
  {
    id: 34,
    name: 'Pack Album + 10 Sobres Fifa World Cup 2026 Panini 70 Lamina',
    category: 'ofertas',
    price: 29890,
    originalPrice: null,
    rating: 3.6,
    reviews: 29,
    badge: 'Nuevo',
    badgeColor: '#2d7a42',
    description: 'Pack de álbum y sobres de la Copa del Mundo 2026 de Panini con 70 láminas.',
    features: ['Álbum con 70 láminas', '10 sobres', 'Copa del Mundo 2026'],
    image: '/images/Imagen36.png',
    paymentLink: 'https://meli.la/2rfut3P',
  },
  {
    id: 36,
    name: 'Pack 10 Sobres Fifa World Cup 2026 Original Panini 70 Lamina',
    category: 'ofertas',
    price: 11990,
    originalPrice: 18990,
    rating: 4.9,
    reviews: 678,
    badge: 'nuevo',
    badgeColor: '#2d7a42',
    description: 'Pack de 10 sobres de la Copa del Mundo 2026 de Panini con 70 láminas.',
    features: ['10 sobres', '70 láminas', 'Copa del Mundo 2026'],
    image: '/images/Imagen37.png',
    paymentLink: 'https://meli.la/2M3sWLj',
  },
   {
    id: 37,
    name: 'Blister 25 Sobres Mundial De Futbol Fifa 2026 Panini 175 Lamina',
    category: 'ofertas',
    price: 41980,
    originalPrice: null,
    rating: 4.9,
    reviews: 212,
    badge: 'nuevo',
    badgeColor: '#2d7a42',
    description: 'Blister con 25 sobres de la Copa del Mundo 2026 de Panini con 175 láminas.',
    features: ['25 sobres', '175 láminas', 'Copa del Mundo 2026'],
    image: '/images/Imagen38.png',
    paymentLink: 'https://meli.la/1CSudJf',
  },
   {
    id: 38,
    name: 'Mercado Pago Máquina Pago Point Smart 2 - Boleta Electrónica',
    category: 'ofertas',
    price: 49990,
    originalPrice: 99800,
    rating: 4.9,
    reviews: 400,
    badge: 'nuevo',
    badgeColor: '#2d7a42',
    description: 'Máquina de pago Point Smart 2 - Boleta Electrónica',
    features: ['Máquina de pago', 'Boleta Electrónica', 'Fácil de usar'],
    image: '/images/Imagen39.png',
    paymentLink: 'https://meli.la/1wNrm63',
  },
     {
    id: 38,
    name: 'SanDisk Ultra Memoria Micro Sd de 128GB 100mbps',
    category: 'ofertas',
    price: 26290,
    originalPrice: 34900,
    rating: 4.9,
    reviews: 400,
    badge: '24% OFF',
    badgeColor: '#e8860a',
    description: 'Memoria Micro Sd de 128GB 100mbps',
    features: ['128GB', '100mbps', 'Fácil de usar'],
    image: '/images/Imagen40.png',
    paymentLink: 'https://meli.la/2yyMgXK',
  },
     {
    id: 39,
    name: 'MProyector mini Casa de los Deseos Smart TV proyector Portatil 9000lm blanco',
    category: 'ofertas',
    price: 39990,
    originalPrice: null,
    rating: 4.3,
    reviews: 1246,
    badge: 'nuevo',
    badgeColor: '#2d7a42',
    description: 'Proyector mini Casa de los Deseos Smart TV proyector Portatil 9000lm blanco',
    features: ['Proyector', 'Smart TV', 'Fácil de usar'],
    image: '/images/Imagen41.png',
    paymentLink: 'https://meli.la/21Mh8Nx',
  },
  {
    id: 40,
    name: 'Perfume Armaf Odyssey Mandarin Sky Limited Edition Edp 100 ml',
    category: 'ofertas',
    price: 27890,
    originalPrice: 49990,
    rating: 4.9,
    reviews: 37116,
    badge: 'nuevo',
    badgeColor: '#2d7a42',
    description: 'Perfume Armaf Odyssey Mandarin Sky Limited Edition Edp 100 ml',
    features: ['Perfume', 'Limited Edition', '100 ml'],
    image: '/images/Imagen42.png',
    paymentLink: 'https://meli.la/1GiKoqt',
  },
  {
    id: 41,
    name: 'Suero Amplificador Para Pestañas Mucho Mas Largas Es La Gloria Entre Rímel',
    category: 'ofertas',
    price: 34990,
    originalPrice: null,
    rating: 4.7,
    reviews: 2253,
    badge: 'nuevo',
    badgeColor: '#2d7a42',
    description: 'Suero Amplificador Para Pestañas Mucho Mas Largas Es La Gloria Entre Rímel',
    features: ['Suero', 'Amplificador', 'Pestañas'],
    image: '/images/Imagen42.png',
    paymentLink: 'https://meli.la/1jgv87n',
  },
];
// Formateador de precio en pesos chilenos
export const formatPrice = (price) =>
  new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 }).format(price);
